import React, { useCallback, useState } from 'react';

import { FilterType } from './filter-utils';
import { FilterBadges } from './subcomponents/filter-badges';
import { FilterSidebar } from './subcomponents/filter-sidebar';
import { GlobalSearch, IGlobalSearchProps } from './subcomponents/global-search';
import { useFilterState } from './use-filter-state';

export type { FilterType } from './filter-utils';
export interface ITableFiltersProps {
  readonly globalFilter?: IGlobalSearchProps['globalFilter'];
  readonly filters: FilterType[];
  readonly className?: string;
}

export function TableFilters({ filters, globalFilter, className }: ITableFiltersProps) {
  const [openFilters, setOpenFilters] = useState(false);

  const {
    tempFilters,
    isInitialized,
    updateTempTextFilter,
    updateTempSelectFilter,
    updateTempMultiSelectFilter,
    updateTempDateFilter,
    applyFilters,
    clearFilter,
  } = useFilterState(filters);

  const handleSaveFilters = useCallback(() => {
    applyFilters();
    setOpenFilters(false);
  }, [applyFilters, setOpenFilters]);

  const onClose = useCallback(() => setOpenFilters(false), [setOpenFilters]);
  const onOpen = useCallback(() => setOpenFilters(true), [setOpenFilters]);

  return (
    <div className={className}>
      <FilterSidebar
        filters={filters}
        isInitialized={isInitialized}
        isOpen={openFilters}
        onClose={onClose}
        onSave={handleSaveFilters}
        tempFilters={tempFilters}
        updateDateFilter={updateTempDateFilter}
        updateMultiSelectFilter={updateTempMultiSelectFilter}
        updateSelectFilter={updateTempSelectFilter}
        updateTextFilter={updateTempTextFilter}
      />

      <div className="flex justify-between">
        <div className="flex items-center">
          <FilterBadges filters={filters} onClearFilter={clearFilter} onOpenFilters={onOpen} />
        </div>

        <GlobalSearch globalFilter={globalFilter} />
      </div>
    </div>
  );
}
